// LogoLoading.jsx

import React from 'react';
import Image from 'next/image';

const LogoLoading = ({isSmall = false}) => {
  const randomNum = Math.floor(Math.random() * 4) + 1;

    return (
        <div className="flex justify-center items-center w-full">
          <Image 
            src={`/images/loadings/loading-2.gif`}
            alt="Loading"
            width={isSmall ? 100 : 200}
            height={isSmall ? 110 : 220}
            unoptimized
          />
        </div>
    );
}

export default LogoLoading;